/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * |-   1. Wall type does not correspond to options available in RdSAP   2. Room heater specified for water heating instead of a range cooker   3. Space heating from individual system and water heating from community system   4. Dwelling has a swimming pool   5. Dwelling has micro-CHP not found in database   6. Storage heater or dual immersion, and single electric meter   7. Heating controlled by TRVs only   8. PVs or wind turbine present on the property (England, Wales or Scotland)   9. Two main heating systems and heating system upgrade is recommended   10. Dual electricity meter selected but there is also an electricity meter for standard tariff   11. Single electricity meter selected but there is also an electricity meter for an off-peak tariff   12. Dwelling is using a biomass fuel that is not in the RdSAP fuel options   13. Park Home   14. Dwelling has a special energy saving feature 
 */
export type AddendumCodeUIDTOV0 = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | '13' | '14';

export const AddendumCodeUIDTOV0 = {
    _1: '1' as AddendumCodeUIDTOV0,
    _2: '2' as AddendumCodeUIDTOV0,
    _3: '3' as AddendumCodeUIDTOV0,
    _4: '4' as AddendumCodeUIDTOV0,
    _5: '5' as AddendumCodeUIDTOV0,
    _6: '6' as AddendumCodeUIDTOV0,
    _7: '7' as AddendumCodeUIDTOV0,
    _8: '8' as AddendumCodeUIDTOV0,
    _9: '9' as AddendumCodeUIDTOV0,
    _10: '10' as AddendumCodeUIDTOV0,
    _11: '11' as AddendumCodeUIDTOV0,
    _12: '12' as AddendumCodeUIDTOV0,
    _13: '13' as AddendumCodeUIDTOV0,
    _14: '14' as AddendumCodeUIDTOV0
};

